module.exports = __webpack_public_path__ + "img/normal_icon.5ab1e584.png";